export const SUBMIT_CREDIT_CARD_FORM_START = "SUBMIT_CREDIT_CARD_FORM_START";
export const SUBMIT_CREDIT_CARD_FORM_SUCCESS =
  "SUBMIT_CREDIT_CARD_FORM_SUCCESS";
export const SUBMIT_CREDIT_CARD_FORM_FAILURE =
  "SUBMIT_CREDIT_CARD_FORM_FAILURE";
